<template>
    <div>
        <!-- <div v-if="infoRetrieved"> -->
            <apexchart v-if="data.categories !== undefined && data.series !== undefined"
                height="250px"
                :width="width ? width : '100%'"
                :type="type ? type: 'line'"
                :options="{
                    chart: {
                        animations: {
                            enabled: false
                        }
                    },
                    title: compound ? 
                        { 
                            text: title.toUpperCase(),
                            align: 'center',
                            style: {
                                fontWeight: 'Bold'
                            } 
                        } : { 
                            text: '' 
                        },
                    xaxis: {
                        type: 'datetime',
                        labels: {
                            show: !historic ? true : false,
                            datetimeUTC: false,
                        }
                    },
                    yaxis : compound ? 
                        {
                            title: { text: ytitle }
                        } : {
                            title: { text: '' }
                        },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '45%', //bar thickness
                        },
                    },
                    tooltip: {
                        x: {
                            show: true,
                            format: !historic ? 'HH:mm' : 'dd',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: !historic ? 'smooth' : undefined,
                    }
                }"
                :series="!historic 
                    ? data.series.map( s => { return { name: `Line ${parseInt(s.line) + 1} - ${s.prop === 'watts' ? 'kilowatts' : s.prop}`, data: s.data } })
                    : data.series.map( s => ({ name: s.prop, data: s.data }) )
                "
            ></apexchart>
            <p v-else>Loading ...</p>
    </div>
</template>

<script>
export default {
    name: 'Home',
    props: ['data', 'type', 'width', 'historic', 'infoRetrieved', 'compound', 'title', 'ytitle'],
};
</script>
<style scoped>
</style>
